// extracted by mini-css-extract-plugin
export default {"testimonial-container":"testimonial_testimonial-container__xQExq","rates":"testimonial_rates__PH-0I","testimonial-car-image":"testimonial_testimonial-car-image__SVSqq"};